import * as React from "react";
import { useCallback } from "react";
import { useField } from "formik";
import { Select } from "components/common";
import { ControlLabel } from "components/bootstrap";
import { Col } from "security-app/components/common/FormBaseStyles";
import { ErrorMessage } from "./ErrorMessage";
function FormikSelect({ field, onChange = void 0, ...props }) {
  const [{ name, value }, { touched, error }, { setValue, setTouched }] = useField({ name: field.name });
  const handleChange = useCallback(
    (newValue) => {
      const sanitizedValue = props.multi ? newValue.split(",") : newValue;
      setValue(sanitizedValue);
      onChange == null ? void 0 : onChange(sanitizedValue);
    },
    [props.multi, setValue, onChange]
  );
  return /* @__PURE__ */ React.createElement(Col, { $fullWidth: true, $width: "100%", $gap: "0", $align: "stretch" }, props.label && /* @__PURE__ */ React.createElement(ControlLabel, null, props.label), /* @__PURE__ */ React.createElement(
    Select,
    {
      ...props,
      inputProps: { "aria-label": name },
      onChange: handleChange,
      onBlur: () => setTouched(true),
      value: Array.isArray(value) ? value.join(",") : value
    }
  ), touched && error && /* @__PURE__ */ React.createElement(ErrorMessage, null, error));
}
export default FormikSelect;
